import React from "react";

import { Context } from "../../managerStore";
import { thisSchoolYear } from "../../libs/Util";

export const useCurrentYear = () => {
  const { state } = React.useContext(Context);

  const result = React.useMemo(() => {
    const currentYear = state.manager.school?.current_year || thisSchoolYear();
    const nextYear = currentYear + 1;

    return {
      currentYear,
      nextYear,
      currentYearShortLabel: String(currentYear).slice(-2),
      nextYearShortLabel: String(nextYear).slice(-2),
    };
  }, [state.manager.school]);

  return result;
};

export default useCurrentYear;
